// extracted by mini-css-extract-plugin
export var chevron = "_k6-2";
export var dropdownItems = "_k6-0";
export var item = "_k6-1";